import * as core from '../../../../../../../core'
import * as testOutcome from '../test-outcome'

export const RESOURCE = {
  payload: {
    description: 'At least one test in the run failed',
    enumId: core.dms.models.Enum.Id.from({
      partialId: testOutcome.RESOURCE.payload.partialId,
    }),
    id: 'FAIL',
    name: 'Fail',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
